import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled, { keyframes } from 'styled-components'
import AnimationContainer from 'components/animation-container'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft, faArrowRight,
} from '@fortawesome/free-solid-svg-icons'


class Hosting extends React.Component {

  shouldComponentUpdate() {
    return false
  }

  constructor(props) {
    super(props)
    this.state = {
      height: 0,
      width: 0
    }
  }

  updateDimensions = () => {
    if (this.state.height !== window.innerHeight) {
      this.setState({ height: window.innerHeight })
    }
    if (this.state.width !== window.innerWidth) {
      this.setState({ width: window.innerWidth })
    }
  }


  componentDidMount() {
    this.setState({ height: window.innerHeight, width: window.innerWidth })
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  render() {

    const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #f6f6f6;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

    const ServiceRow = styled(Row)`
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
            display: flex;
        `

    const ServiceHeading = styled.h3`
            font-size: 18px;
            font-weight: 700;
            color: #212122;
            @media (max-width: 767px) {
              font-size: 16px;
          }
        `

    const Heading = styled.h2`
            font-size: 24px;
            font-weight: 700;
            color: #212122;
            text-align:center;
        `

    const ServiceHeadinga = styled.a`
            color: #000;         
            &:before {
              content: '';
              position: absolute;
              top: 35px;
              bottom: 0;
              left: 28%;
              width: 1px;
              height: 50%;
              background: #ebebeb;
              transition: all .3s ease;
            }
            &:hover {
              color: #65ff00;              
            }
        `

    const ServiceText = styled.p`
            font-size: 16px;
            line-height: 26px;
            color: #808080;
            margin-top: 5px;
            font-family: 'Open Sans',sans-serif;
            font-weight: normal;
            @media (max-width: 767px) {
              font-size: 14px;
              line-height: 20px;
            }
        `

    const Inform = styled.div`
            width: 72%;
            padding: 10px 30px;
            display: inline-block;
            vertical-align: middle;
        `

    const ServiceWrap = styled.div`            
            font-weight: bold;
            color: #ff6d37;            
        `

    const AnimatedShadow = keyframes`
            0%   {box-shadow: 0 2px 60px rgba(126, 126, 126, .5);}
            10%  {box-shadow: 0 4px 60px rgba(80,115,184, .5);}
            20%  {box-shadow: 0 6px 60px rgba(80,115,184, .5);}
            30%  {box-shadow: 0 10px 60px rgba(126, 126, 126, .5);}
            40% {box-shadow: 0 14px 60px rgba(80, 115, 184, .5);}
            50% {box-shadow: 0 16px 60px rgba(126, 126, 126, .5);}
            60% {box-shadow: 0 18px 60px rgba(62, 62, 62, .5);}
            70% {box-shadow: 0 22px 60px rgba(62, 62, 62, .5);}
            80% {box-shadow: 0 24px 60px rgba(80, 115, 184, .5);}
            90% {box-shadow: 0 26px 60px rgba(16, 152, 173, .5);}
            100% {box-shadow: 0 28px 60px rgba(126, 126, 126, .5);}
            -webkit-transition: all 300ms linear 0ms;
	          -moz-transition: all 300ms linear 0ms;
	          -ms-transition: all 300ms linear 0ms;
	          transition: all 300ms linear 0ms;
            transition: all .3s ease;
        `

    const HelpContainer = styled.div`            
            position: relative;
            height: 145px;
            margin-top: 50px;
            border-radius: 3px;
            background-color: #fff;
            box-shadow: 0 5px 15px 0 rgba(110, 110, 110, .1);
            transition: all .3s ease;
            &:hover {
              background-color: #fff;
              animation: ${AnimatedShadow} 10s infinite alternate;
              transform: translateY(-5px);
              
          }
        `

    const Img = styled.div`            
            display: inline-block;
            vertical-align: middle;
            position: relative;
            width: 28%;
            height: 100%;
        `

    const Ico = styled.svg`            
            position: absolute;
            top: 30%;
            left: 20%;
            @media (max-width: 767px) {
              left: -10%;
            }
        `

    const IcoC = styled.svg`            
            position: absolute;
            top: 30%;
            left: 20%;
            @media (max-width: 767px) {
              left: 10%;
            }
        `

    const BadgeGrey = styled.div`
            position: absolute;
            right: auto;
            left: 10px !important;
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

    const BadgeGreyR = styled.div`
            position: absolute;
            right: 10px;            
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

    return (
      <Section>
        <Container>
          <Col md={12}>
            <Heading>
              ¿Necesitas mas prestaciones o servicios más robustos?
            </Heading>
          </Col>
          <ServiceWrap>
            <ServiceRow>
              <Col md={6}>
                <AnimationContainer animation="fadeInDown" delay={500}>
                  <HelpContainer>
                    <BadgeGrey><FontAwesomeIcon icon={faArrowLeft} size="1x" /></BadgeGrey>
                    <Img>
                      <Ico>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1222 720">
                          <style>{`
                              .cls-1 {
                                fill: #ff6c2c;
                                }
                                `}</style>
                          <g data-name="Layer 2">
                            <path d="M89.69 59.1h67.8L147 99.3a25.38 25.38 0 0 1-9 13.5 24.32 24.32 0 0 1-15.3 5.1H91.19a30.53 30.53 0 0 0-19 6.3 33 33 0 0 0-11.55 17.1 31.91 31.91 0 0 0-.45 15.3A33.1 33.1 0 0 0 66 169.35a30.29 30.29 0 0 0 10.8 8.85 31.74 31.74 0 0 0 14.4 3.3h19.2a10.8 10.8 0 0 1 8.85 4.35 10.4 10.4 0 0 1 2 9.75l-12 44.4h-21a84.77 84.77 0 0 1-39.75-9.45 89.78 89.78 0 0 1-30.21-25.05A88.4 88.4 0 0 1 1.94 170 87.51 87.51 0 0 1 3 129l1.2-4.5a88.69 88.69 0 0 1 31.64-47.25 89.91 89.91 0 0 1 25-13.35 87 87 0 0 1 28.85-4.8Zm34.2 180.9L183 18.6a25.38 25.38 0 0 1 9-13.5A24.28 24.28 0 0 1 207.29 0H270a84.8 84.8 0 0 1 39.75 9.45 89.21 89.21 0 0 1 46.65 60.6 83.8 83.8 0 0 1-1.2 41l-1.2 4.5a89.88 89.88 0 0 1-12 26.55 87.65 87.65 0 0 1-73.2 39.15h-54.3l10.8-40.5a25.38 25.38 0 0 1 9-13.2 24.32 24.32 0 0 1 15.3-5.1H267a31.56 31.56 0 0 0 30.6-23.7A29.5 29.5 0 0 0 298 84a33.1 33.1 0 0 0-5.85-12.75 31.85 31.85 0 0 0-10.8-9A30.61 30.61 0 0 0 267 58.8h-33.6l-43.8 162.9a25.38 25.38 0 0 1-9 13.2 23.88 23.88 0 0 1-15 5.1ZM361.18 32.31h-3.71V3.71h-10.1V.42h23.91v3.29h-10.1Zm29.01 0L379.37 4h-.17q.3 3.36.3 8v20.31h-3.42V.42h5.58l10.1 26.3h.18L402.12.42h5.54v31.89H404V11.76c0-2.36.11-4.91.31-7.68h-.17l-10.96 28.23Z" class="cls-1" data-name="Layer 1" />
                          </g>
                        </svg>
                      </Ico>
                    </Img>
                    <Inform>
                      <ServiceHeading>
                        <ServiceHeadinga href="/hosting-cpanel">
                          Hosting cPanel – Gestión Simplificada
                        </ServiceHeadinga>
                      </ServiceHeading>
                      <ServiceText>Administra tu hosting con cPanel, ideal para WordPress en Pereira y Bogotá.</ServiceText>
                    </Inform>
                  </HelpContainer>
                </AnimationContainer>
              </Col>
              <Col md={6}>
                <AnimationContainer animation="fadeInDown" delay={500}>
                  <HelpContainer>
                    <BadgeGreyR><FontAwesomeIcon icon={faArrowRight} size="1x" /></BadgeGreyR>
                    <Img>
                      <IcoC><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32" alt="Cloud">
                        <path id="svg-ico" fill="#abd363" d="M21.294 1.969c-0.012 0-0.025 0-0.038 0h-0.156c-0.012 0-0.025 0-0.038 0-5.325 0.087-10.656 3.756-10.656 10.688 0 0.238 0.194 0.425 0.425 0.425 0.238 0 0.425-0.194 0.425-0.425 0-6.719 5.125-9.8 9.912-9.838 5.387 0.038 9.762 4.438 9.762 9.838 0 5.425-4.412 9.837-9.838 9.837h-13.325c-3.725 0-6.756-3.031-6.756-6.756s3.031-6.756 6.756-6.756c0.238 0 0.425-0.194 0.425-0.425s-0.194-0.425-0.425-0.425c-4.2-0.006-7.612 3.412-7.612 7.606s3.413 7.613 7.612 7.613h13.331c5.894 0 10.694-4.794 10.694-10.694 0-5.825-4.694-10.581-10.5-10.688z"></path>
                        <path fill="#5e686c" d="M24.413 28.15h-6.781c-0.156-0.6-0.631-1.075-1.231-1.231v-2.194c0-0.238-0.194-0.425-0.425-0.425-0.238 0-0.425 0.194-0.425 0.425v2.194c-0.6 0.156-1.075 0.631-1.231 1.231h-6.781c-0.237 0-0.425 0.194-0.425 0.425s0.194 0.425 0.425 0.425h6.781c0.188 0.738 0.863 1.281 1.656 1.281s1.469-0.544 1.656-1.281h6.781c0.238 0 0.425-0.194 0.425-0.425s-0.188-0.425-0.425-0.425zM15.975 29.431c-0.469 0-0.856-0.381-0.856-0.856 0 0 0 0 0 0s0 0 0 0c0-0.469 0.381-0.856 0.856-0.856s0.856 0.381 0.856 0.856c0 0.475-0.387 0.856-0.856 0.856z"></path>
                        <path fill="#5e686c" d="M21.238 6.931c0.238 0 0.425-0.194 0.425-0.431-0.006-0.237-0.219-0.444-0.431-0.425-3.381 0.044-6.375 2.719-6.675 6.044l0.006 0.075c0.006 0.156 0.012 0.313 0.012 0.463 0 0.238 0.194 0.425 0.425 0.425 0.238 0 0.425-0.194 0.425-0.425 0-0.162-0.006-0.331-0.012-0.525l-0.012-0.019c0.269-2.819 2.888-5.144 5.838-5.181z"></path>
                      </svg>
                      </IcoC>
                    </Img>
                    <Inform>
                      <ServiceHeading>
                        <ServiceHeadinga href="/cloud">
                          Hosting Cloud – Escalabilidad Total
                        </ServiceHeadinga>
                      </ServiceHeading>
                      <ServiceText>Hosting cloud para proyectos grandes en Bucaramanga y Dosquebradas.</ServiceText>
                    </Inform>
                  </HelpContainer>
                </AnimationContainer>
              </Col>
            </ServiceRow>
          </ServiceWrap>
        </Container>
      </Section>
    )
  }

}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      query {
        background: file(relativePath: {eq: "background-poly.jpg"}) {
          childImageSharp {
            fluid(maxWidth: 2000, quality: 100) {
              src
            }
          }
        }
        webexpertIcon: file(relativePath: {eq: "icons/mobile.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        mobileIcon: file(relativePath: {eq: "icons/SSL.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        seoIcon: file(relativePath: {eq: "icons/network.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
      }
      `}
    render={({
      background,
      webexpertIcon,
      mobileIcon,
      seoIcon }) => <Hosting
        background={background}
        webexpertIcon={webexpertIcon}
        mobileIcon={mobileIcon}
        seoIcon={seoIcon}
        {...props} />}
  />
);
export default Iconos;

